export default {"src":"/_next/static/media/30.9c27fdfb.svg","height":384,"width":450,"blurWidth":0,"blurHeight":0};